/**
 * 專案存儲庫
 * 處理專案的創建、查詢、更新和刪除等操作
 */

import { Project, CreateProjectRequest, UpdateProjectRequest } from "../models";
import { api, endpoints } from "@/infrastructure/api";

/**
 * 專案存儲庫
 * 負責專案數據的存取和 API 交互
 */
export const projectRepository = {
  /**
   * 獲取專案列表
   * @returns 專案列表
   */
  async getProjects(): Promise<Project[]> {
    return await api.get<Project[]>(endpoints.projects.list);
  },

  /**
   * 根據 ID 獲取專案詳情
   * @param id 專案 ID
   * @returns 專案詳情
   */
  async getProjectById(id: string): Promise<Project> {
    return await api.get<Project>(endpoints.projects.detail(id));
  },

  /**
   * 創建新專案
   * @param project 專案創建請求數據
   * @returns 新創建的專案
   */
  async createProject(project: CreateProjectRequest): Promise<Project> {
    return await api.post<Project>(endpoints.projects.list, project);
  },

  /**
   * 更新專案
   * @param id 專案 ID
   * @param project 專案更新請求數據
   * @returns 更新後的專案
   */
  async updateProject(
    id: string,
    project: UpdateProjectRequest,
  ): Promise<Project> {
    return await api.put<Project>(endpoints.projects.detail(id), project);
  },

  /**
   * 刪除專案
   * @param id 專案 ID
   */
  async deleteProject(id: string): Promise<void> {
    await api.delete<void>(endpoints.projects.detail(id));
  },
};
